'use strict';

const rules = require('./rules');

const ATTRIBUTE_VALIDATE_FUNCTIONS = {
    mandatory: rules.validateMandatory,
    minLength: rules.validateMinLength,
    maxLength: rules.validateMaxLength,
    minValue: rules.validateMinValue,
    maxValue: rules.validateMaxValue,
    regEx: rules.validateRegEx,
    scriptRegEx: rules.validateScriptValueRegEx
};

const TYPE_VALIDATE_FUNCTIONS = {
    email: rules.validateEmail,
    date: rules.validateDate
};

/**
 * Form Validator Object
 */
const validator = {
    /**
     * Validates a form element
     * @param {JSON Object} el The JSON object describing the form element
     * @returns Array
     */
    validateElement(el) {
        const errors = [
            ...validator.validateElementAttributes(el),
            ...validator.validateElementTypes(el)
        ];

        return errors;
    },

    /**
     * Validates the attributes of a form element
     * @param {JSON Object} el The JSON Object describing the form element
     * @returns Array
     */
    validateElementAttributes(el) {
        const errors = [];

        for (const [key, value] of Object.entries(ATTRIBUTE_VALIDATE_FUNCTIONS)) { /* eslint-disable-line no-unused-vars */
            if (!el.attributes.hasOwnProperty(key) || el.attributes[key] === null) { /* eslint-disable-line no-prototype-builtins */
                continue;
            }

            const result = ATTRIBUTE_VALIDATE_FUNCTIONS[key](el);
            if (result.valid) {
                continue;
            }

            errors.push(result.errorMessage);
            break;
        }

        return errors;
    },

    /**
     * Validates the types of a form element
     * @param {JSON Object} el The JSON Object describing the form element
     * @returns Array
     */
    validateElementTypes(el) {
        const errors = [];

        for (const [key, value] of Object.entries(TYPE_VALIDATE_FUNCTIONS)) { /* eslint-disable-line no-unused-vars */
            if (!el.elementDataType || el.elementDataType !== key) {
                continue;
            }

            const typeResult = TYPE_VALIDATE_FUNCTIONS[key](el);
            if (typeResult.valid) {
                continue;
            }

            errors.push(typeResult.errorMessage);
        }

        return errors;
    },
    /**
     * Soft validates the attributes of a form element
     * @param {JSON Object} el The JSON Object describing the form element
     * @returns Array
     */
    softValidateElementAttributes(el) {
        const errors = [];
        const result = rules.softValidateRegEx(el);
        if (!result.valid) {
            errors.push(result.errorMessage);
        }
        return errors;
    }
};

module.exports = validator;
